// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview_search.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { AppExpandMask } from "../../app/v1/app";
import { AppView } from "../../app/v1/app";
import { AppUserExpandMask } from "../../app/v1/app_user";
import { TaskView } from "../../task/v1/task";
import { AppEntitlementView } from "../../app/v1/app_entitlement";
import { AppUserView } from "../../app/v1/app_user";
import { AppResourceTypeView } from "../../app/v1/app_resource";
import { AppResource } from "../../app/v1/app_resource";
import { UserExpandMask } from "../../user/v1/user";
import { UserView } from "../../user/v1/user";
import { AppUser } from "../../app/v1/app_user";
import { AccessReviewEntitlementRollup } from "./accessreview";
import { AccessReviewEntitlementRollupByApp } from "./accessreview";
import { AccessReviewEntitlementRollupExpandMask } from "./accessreview";
import { Facets } from "../../search/v1/facet";
import { AccessReviewAppEntitlementView } from "./accessreview";
import { AccessReviewAppEntitlementExpandMask } from "./accessreview";
import { AccessReview } from "./accessreview";
import { App } from "../../app/v1/app";
import { User } from "../../user/v1/user";
import { Any } from "../../../../google/protobuf/any";
import { AccessReviewView } from "./accessreview";
import { PolicyRef } from "../../policy/v1/policy";
import { AccessReviewRef } from "./accessreview";
import { SortOptions } from "../../search/v1/sort";
import { AccessReviewExpandMask } from "./accessreview";
import { AccessReviewState } from "./accessreview";
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchRequest
 */
export interface AccessReviewSearchServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewState access_review_states = 4;
     */
    accessReviewStates: AccessReviewState[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 5;
     */
    expandMask?: AccessReviewExpandMask;
    /**
     * @generated from protobuf field: c1.api.search.v1.SortOptions sort_options = 7;
     */
    sortOptions?: SortOptions;
    /**
     * @generated from protobuf field: repeated string owner_ids = 8;
     */
    ownerIds: string[];
    /**
     * @generated from protobuf field: string access_review_template_id = 9;
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewRef refs = 10;
     */
    refs: AccessReviewRef[];
    /**
     * Search for access reviews that use any of these policies.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyRef policy_refs = 11;
     */
    policyRefs: PolicyRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchResponse
 */
export interface AccessReviewSearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewView list = 1;
     */
    list: AccessReviewView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSelectionsStatusRequest
 */
export interface AccessReviewSearchServiceSelectionsStatusRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserRequest
 */
export interface AccessReviewSearchServiceCountOpenReviewsByUserRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * If not specified, defaults to returning all reviewers.
     *
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewerCompletionFilter reviewer_completion_filter = 4;
     */
    reviewerCompletionFilter: ReviewerCompletionFilter;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserResponse
 */
export interface AccessReviewSearchServiceCountOpenReviewsByUserResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.UserToReviewCount list = 1;
     */
    list: UserToReviewCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountCompleteReviewersRequest
 */
export interface AccessReviewSearchServiceCountCompleteReviewersRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountCompleteReviewersResponse
 */
export interface AccessReviewSearchServiceCountCompleteReviewersResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountIncompleteReviewersRequest
 */
export interface AccessReviewSearchServiceCountIncompleteReviewersRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountIncompleteReviewersResponse
 */
export interface AccessReviewSearchServiceCountIncompleteReviewersResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsRequest
 */
export interface AccessReviewSearchServiceGetReviewerDecisionsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewerDecisionSort sort = 4;
     */
    sort: ReviewerDecisionSort;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsResponse
 */
export interface AccessReviewSearchServiceGetReviewerDecisionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.ReviewerDecision list = 1;
     */
    list: ReviewerDecision[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ReviewerDecision
 */
export interface ReviewerDecision {
    /**
     * Deprecated: Use user_id instead and fetch user details separately.
     *
     * @deprecated
     * @generated from protobuf field: c1.api.user.v1.User user = 1 [deprecated = true];
     */
    user?: User;
    /**
     * @generated from protobuf field: int64 approved = 2;
     */
    approved: number;
    /**
     * @generated from protobuf field: int64 denied = 3;
     */
    denied: number;
    /**
     * @generated from protobuf field: int64 total_assigned = 4;
     */
    totalAssigned: number;
    /**
     * @generated from protobuf field: int64 approval_rate = 5;
     */
    approvalRate: number;
    /**
     * @generated from protobuf field: string user_id = 6;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.UserToReviewCount
 */
export interface UserToReviewCount {
    /**
     * Deprecated: Use user_id instead and fetch user details separately.
     *
     * @deprecated
     * @generated from protobuf field: c1.api.user.v1.User user = 1 [deprecated = true];
     */
    user?: User;
    /**
     * @generated from protobuf field: int64 open_reviews = 2;
     */
    openReviews: number;
    /**
     * @generated from protobuf field: int64 total_reviews = 3;
     */
    totalReviews: number;
    /**
     * @generated from protobuf field: string user_id = 4;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppRequest
 */
export interface AccessReviewSearchServiceGetProgressByAppRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppResponse
 */
export interface AccessReviewSearchServiceGetProgressByAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppProgressCount list = 1;
     */
    list: AppProgressCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AppProgressCount
 */
export interface AppProgressCount {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1;
     */
    app?: App;
    /**
     * @generated from protobuf field: int64 open_count = 2;
     */
    openCount: number;
    /**
     * @generated from protobuf field: int64 closed_count = 3;
     */
    closedCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSelectionsStatusResponse
 */
export interface AccessReviewSearchServiceSelectionsStatusResponse {
    /**
     * @generated from protobuf field: int32 total = 1;
     */
    total: number;
    /**
     * @generated from protobuf field: int32 certified = 2;
     */
    certified: number;
    /**
     * @generated from protobuf field: int32 rejected = 3;
     */
    rejected: number;
    /**
     * @generated from protobuf field: int32 skipped = 4;
     */
    skipped: number;
    /**
     * @generated from protobuf field: int32 cancelled = 5;
     */
    cancelled: number;
    /**
     * @generated from protobuf field: int32 deleted = 6;
     */
    deleted: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewRollup
 */
export interface AccessReviewRollup {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReview access_review = 1;
     */
    accessReview?: AccessReview;
    /**
     * @generated from protobuf field: int32 assigned_tasks = 2;
     */
    assignedTasks: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceRollupRequest
 */
export interface AccessReviewSearchServiceRollupRequest {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: bool exclude_completed = 4;
     */
    excludeCompleted: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceRollupResponse
 */
export interface AccessReviewSearchServiceRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewRollup list = 1;
     */
    list: AccessReviewRollup[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsRequest
 */
export interface AccessReviewSearchServiceSearchEntitlementsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 5;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 6;
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string risk_level_ids = 7;
     */
    riskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string compliance_framework_ids = 8;
     */
    complianceFrameworkIds: string[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask expand_mask = 9;
     */
    expandMask?: AccessReviewAppEntitlementExpandMask;
    /**
     * @generated from protobuf field: bool exclude_facets = 10;
     */
    excludeFacets: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsResponse
 */
export interface AccessReviewSearchServiceSearchEntitlementsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppEntitlementView list = 1;
     */
    list: AccessReviewAppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 4;
     */
    facets?: Facets;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsCountRequest
 */
export interface AccessReviewSearchServiceSearchEntitlementsCountRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 5;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 6;
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string risk_level_ids = 7;
     */
    riskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string compliance_framework_ids = 8;
     */
    complianceFrameworkIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsCountResponse
 */
export interface AccessReviewSearchServiceSearchEntitlementsCountResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppRollup
 */
export interface AccessReviewAppRollup {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1;
     */
    app?: App;
    /**
     * @generated from protobuf field: int32 assigned_tasks = 2;
     */
    assignedTasks: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 3;
     */
    completedTasksCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRef
 */
export interface AccessReviewSearchServiceEntitlementRollupRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRequest
 */
export interface AccessReviewSearchServiceEntitlementRollupRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewEntitlementRollupExpandMask expand_mask = 5;
     */
    expandMask?: AccessReviewEntitlementRollupExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRef refs = 6;
     */
    refs: AccessReviewSearchServiceEntitlementRollupRef[];
    /**
     * @generated from protobuf field: string query = 7;
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupResponse
 */
export interface AccessReviewSearchServiceEntitlementRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewEntitlementRollupByApp list = 1;
     */
    list: AccessReviewEntitlementRollupByApp[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupByAppRequest
 */
export interface AccessReviewSearchServiceEntitlementRollupByAppRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewEntitlementRollupExpandMask expand_mask = 5;
     */
    expandMask?: AccessReviewEntitlementRollupExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRef refs = 6;
     */
    refs: AccessReviewSearchServiceEntitlementRollupRef[];
    /**
     * @generated from protobuf field: string query = 7;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 8;
     */
    appIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupByAppResponse
 */
export interface AccessReviewSearchServiceEntitlementRollupByAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewEntitlementRollup list = 1;
     */
    list: AccessReviewEntitlementRollup[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserRollup
 */
export interface AccessReviewAppUserRollup {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 1;
     */
    appUser?: AppUser;
    /**
     * @generated from protobuf field: int32 task_count = 2;
     */
    taskCount: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 3;
     */
    completedTasksCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAccountsWithNoIdentityTaskCounts
 */
export interface AccessReviewAccountsWithNoIdentityTaskCounts {
    /**
     * @generated from protobuf field: int32 open_task_count = 1;
     */
    openTaskCount: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 2;
     */
    completedTasksCount: number;
    /**
     * @generated from protobuf field: int64 pending_actions_count = 3;
     */
    pendingActionsCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAccountsWithNoIdentityTaskStatus
 */
export interface AccessReviewAccountsWithNoIdentityTaskStatus {
    /**
     * @generated from protobuf field: bool has_open_tasks = 1;
     */
    hasOpenTasks: boolean;
    /**
     * @generated from protobuf field: bool has_completed_tasks = 2;
     */
    hasCompletedTasks: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewUserRollup
 */
export interface AccessReviewUserRollup {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserView user = 1;
     */
    user?: UserView;
    /**
     * @generated from protobuf field: int32 open_task_count = 2;
     */
    openTaskCount: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 3;
     */
    completedTasksCount: number;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 4;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string id = 5;
     */
    id: string;
    /**
     * @generated from protobuf field: int64 pending_actions_count = 6;
     */
    pendingActionsCount: number;
    /**
     * @generated from protobuf field: int64 pending_submission_count = 7;
     */
    pendingSubmissionCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRef
 */
export interface AccessReviewSearchServiceUserRollupRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRequest
 */
export interface AccessReviewSearchServiceUserRollupRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2;
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRef refs = 5;
     */
    refs: AccessReviewSearchServiceUserRollupRef[];
    /**
     * @generated from protobuf field: string query = 6;
     */
    query: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 7;
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupResponse
 */
export interface AccessReviewSearchServiceUserRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewUserRollup list = 1;
     */
    list: AccessReviewUserRollup[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccountsWithNoIdentityTaskCountsRequest
 */
export interface AccountsWithNoIdentityTaskCountsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2;
     */
    reviewerUserId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccountsWithNoIdentityTaskStatusRequest
 */
export interface AccountsWithNoIdentityTaskStatusRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2;
     */
    reviewerUserId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupUserNavDataRequest
 */
export interface AccessReviewSearchServiceUserRollupUserNavDataRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2;
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: string current_user_id = 3;
     */
    currentUserId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupUserNavDataResponse
 */
export interface AccessReviewSearchServiceUserRollupUserNavDataResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewUserRollup previous_user = 1;
     */
    previousUser?: AccessReviewUserRollup;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewUserRollup current_user = 2;
     */
    currentUser?: AccessReviewUserRollup;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewUserRollup next_user = 3;
     */
    nextUser?: AccessReviewUserRollup;
    /**
     * @generated from protobuf field: string user_id = 4;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchAppUsersRequest
 */
export interface AccessReviewSearchServiceSearchAppUsersRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string query = 2;
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchAppUsersResponse
 */
export interface AccessReviewSearchServiceSearchAppUsersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUser list = 1;
     */
    list: AppUser[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppResourceRollupItem
 */
export interface AccessReviewAppResourceRollupItem {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResource item = 1;
     */
    item?: AppResource;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppEntitlementView entitlements = 2;
     */
    entitlements: AccessReviewAppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ResourceRollupRef
 */
export interface ResourceRollupRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_id = 2;
     */
    appResourceId: string;
    /**
     * @generated from protobuf field: string access_review_id = 3;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceRollupRequest
 */
export interface AccessReviewSearchServiceSearchSelectedResourceRollupRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask expand_mask = 4;
     */
    expandMask?: AccessReviewAppEntitlementExpandMask;
    /**
     * @generated from protobuf field: string query = 6;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.ResourceRollupRef refs = 7;
     */
    refs: ResourceRollupRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceRollupResponse
 */
export interface AccessReviewSearchServiceSearchSelectedResourceRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppResourceRollupItem list = 1;
     */
    list: AccessReviewAppResourceRollupItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: string access_review_id = 3;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppResourceTypeRollupItem
 */
export interface AccessReviewAppResourceTypeRollupItem {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceTypeView item = 1;
     */
    item?: AppResourceTypeView;
    /**
     * @generated from protobuf field: int64 resource_count = 2;
     */
    resourceCount: number;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ResourceTypeRollupRef
 */
export interface ResourceTypeRollupRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_type_id = 2;
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: string access_review_id = 3;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest
 */
export interface AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.ResourceTypeRollupRef refs = 5;
     */
    refs: ResourceTypeRollupRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse
 */
export interface AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppResourceTypeRollupItem list = 1;
     */
    list: AccessReviewAppResourceTypeRollupItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: string access_review_id = 3;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRef
 */
export interface AccessReviewAppUserDetailRowSearchRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2;
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewUserNavRollupRef
 */
export interface AccessReviewUserNavRollupRef {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppNavRollupRef
 */
export interface AccessReviewAppNavRollupRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRequest
 */
export interface AccessReviewAppUserDetailRowSearchRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string identity_user_id = 2;
     */
    identityUserId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 3;
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 4;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewAppUserDetailRowExpandMask expand_mask = 6;
     */
    expandMask?: AccessReviewAppUserDetailRowExpandMask;
    /**
     * @generated from protobuf field: repeated string app_user_ids = 7;
     */
    appUserIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRef refs = 8;
     */
    refs: AccessReviewAppUserDetailRowSearchRef[];
    /**
     * @generated from protobuf field: repeated string app_ids = 9;
     */
    appIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchResponse
 */
export interface AccessReviewAppUserDetailRowSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRow list = 1;
     */
    list: AccessReviewAppUserDetailRow[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserRollupNavDataRequest
 */
export interface AccessReviewAppUserRollupNavDataRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string identity_user_id = 2;
     */
    identityUserId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 3;
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: string app_id = 4;
     */
    appId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewAppUserDetailRowExpandMask expand_mask = 5;
     */
    expandMask?: AccessReviewAppUserDetailRowExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserRollupNavDataResponse
 */
export interface AccessReviewAppUserRollupNavDataResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserView previous_user = 1;
     */
    previousUser?: AppUserView;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserView current_user = 2;
     */
    currentUser?: AppUserView;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserView next_user = 3;
     */
    nextUser?: AppUserView;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavFirstOpenSelectionRequest
 */
export interface AccessReviewSearchServiceNavFirstOpenSelectionRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2;
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NextOpenSelectionType type = 3;
     */
    type: NextOpenSelectionType;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavFirstOpenSelectionResponse
 */
export interface AccessReviewSearchServiceNavFirstOpenSelectionResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NextOpenSelectionType type = 2;
     */
    type: NextOpenSelectionType;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavNextSelectionRequest
 */
export interface AccessReviewSearchServiceNavNextSelectionRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2;
     */
    reviewerUserId: string;
    /**
     * no validation for current_user_id, as rpc can request next for unassigned
     *
     * @generated from protobuf field: string current_id = 5;
     */
    currentId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NextOpenSelectionType type = 4;
     */
    type: NextOpenSelectionType;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavNextSelectionResponse
 */
export interface AccessReviewSearchServiceNavNextSelectionResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NextOpenSelectionType type = 2;
     */
    type: NextOpenSelectionType;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowExpandMask
 */
export interface AccessReviewAppUserDetailRowExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowTaskDetails
 */
export interface AccessReviewAppUserDetailRowTaskDetails {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1;
     */
    entitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task = 2;
     */
    task?: TaskView;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRow
 */
export interface AccessReviewAppUserDetailRow {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserView app_user = 1;
     */
    appUser?: AppUserView;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRowTaskDetails entitlements = 2;
     */
    entitlements: AccessReviewAppUserDetailRowTaskDetails[];
    /**
     * @generated from protobuf field: bool AllTicketsCompleted = 3 [json_name = "AllTicketsCompleted"];
     */
    allTicketsCompleted: boolean;
    /**
     * @generated from protobuf field: string app_id = 4;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 5;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: int64 pending_actions_count = 6;
     */
    pendingActionsCount: number;
    /**
     * @generated from protobuf field: int32 open_task_count = 7;
     */
    openTaskCount: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 8;
     */
    completedTasksCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AppUserRollup
 */
export interface AppUserRollup {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserView app_user = 1;
     */
    appUser?: AppUserView;
    /**
     * @generated from protobuf field: int32 open_task_count = 3;
     */
    openTaskCount: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 4;
     */
    completedTasksCount: number;
    /**
     * @generated from protobuf field: int32 pending_submission_count = 5;
     */
    pendingSubmissionCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchAppUserRollupRequest
 */
export interface SearchAppUserRollupRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string identity_user_id = 2;
     */
    identityUserId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 3;
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 4;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 6;
     */
    expandMask?: AppUserExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRef refs = 7;
     */
    refs: AccessReviewAppUserDetailRowSearchRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchAppUserRollupResponse
 */
export interface SearchAppUserRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserRollup list = 1;
     */
    list: AppUserRollup[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AppRollup
 */
export interface AppRollup {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppView app = 1;
     */
    app?: AppView;
    /**
     * @generated from protobuf field: int32 task_count = 2;
     */
    taskCount: number;
    /**
     * @generated from protobuf field: int32 open_task_count = 3;
     */
    openTaskCount: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 4;
     */
    completedTasksCount: number;
    /**
     * @generated from protobuf field: int32 pending_submission_count = 5;
     */
    pendingSubmissionCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchAppRollupRequest
 */
export interface SearchAppRollupRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2;
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppExpandMask expand_mask = 5;
     */
    expandMask?: AppExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppNavRollupRef refs = 6;
     */
    refs: AccessReviewAppNavRollupRef[];
    /**
     * @generated from protobuf field: string query = 7;
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchAppRollupResponse
 */
export interface SearchAppRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppRollup list = 1;
     */
    list: AppRollup[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.ReviewerCompletionFilter
 */
export enum ReviewerCompletionFilter {
    /**
     * @generated from protobuf enum value: REVIEWER_COMPLETION_FILTER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REVIEWER_COMPLETION_FILTER_ALL = 1;
     */
    ALL = 1,
    /**
     * @generated from protobuf enum value: REVIEWER_COMPLETION_FILTER_COMPLETE = 2;
     */
    COMPLETE = 2,
    /**
     * @generated from protobuf enum value: REVIEWER_COMPLETION_FILTER_INCOMPLETE = 3;
     */
    INCOMPLETE = 3
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.ReviewerDecisionSort
 */
export enum ReviewerDecisionSort {
    /**
     * @generated from protobuf enum value: REVIEWER_DECISION_SORT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REVIEWER_DECISION_SORT_APPROVAL_RATE_ASC = 1;
     */
    APPROVAL_RATE_ASC = 1,
    /**
     * @generated from protobuf enum value: REVIEWER_DECISION_SORT_APPROVAL_RATE_DESC = 2;
     */
    APPROVAL_RATE_DESC = 2,
    /**
     * @generated from protobuf enum value: REVIEWER_DECISION_SORT_TOTAL_ASSIGNED_ASC = 3;
     */
    TOTAL_ASSIGNED_ASC = 3,
    /**
     * @generated from protobuf enum value: REVIEWER_DECISION_SORT_TOTAL_ASSIGNED_DESC = 4;
     */
    TOTAL_ASSIGNED_DESC = 4
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.NextOpenSelectionType
 */
export enum NextOpenSelectionType {
    /**
     * @generated from protobuf enum value: NEXT_OPEN_SELECTION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: NEXT_OPEN_SELECTION_TYPE_APP = 1;
     */
    APP = 1,
    /**
     * @generated from protobuf enum value: NEXT_OPEN_SELECTION_TYPE_USER = 2;
     */
    USER = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchRequest$Type extends MessageType<AccessReviewSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "access_review_states", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AccessReviewState", AccessReviewState, "ACCESS_REVIEW_STATE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AccessReviewExpandMask },
            { no: 7, name: "sort_options", kind: "message", T: () => SortOptions },
            { no: 8, name: "owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 10, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewRef },
            { no: 11, name: "policy_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchRequest
 */
export const AccessReviewSearchServiceSearchRequest = new AccessReviewSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchResponse$Type extends MessageType<AccessReviewSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchResponse
 */
export const AccessReviewSearchServiceSearchResponse = new AccessReviewSearchServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSelectionsStatusRequest$Type extends MessageType<AccessReviewSearchServiceSelectionsStatusRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSelectionsStatusRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSelectionsStatusRequest
 */
export const AccessReviewSearchServiceSelectionsStatusRequest = new AccessReviewSearchServiceSelectionsStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceCountOpenReviewsByUserRequest$Type extends MessageType<AccessReviewSearchServiceCountOpenReviewsByUserRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "reviewer_completion_filter", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewerCompletionFilter", ReviewerCompletionFilter, "REVIEWER_COMPLETION_FILTER_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserRequest
 */
export const AccessReviewSearchServiceCountOpenReviewsByUserRequest = new AccessReviewSearchServiceCountOpenReviewsByUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceCountOpenReviewsByUserResponse$Type extends MessageType<AccessReviewSearchServiceCountOpenReviewsByUserResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserToReviewCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserResponse
 */
export const AccessReviewSearchServiceCountOpenReviewsByUserResponse = new AccessReviewSearchServiceCountOpenReviewsByUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceCountCompleteReviewersRequest$Type extends MessageType<AccessReviewSearchServiceCountCompleteReviewersRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceCountCompleteReviewersRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountCompleteReviewersRequest
 */
export const AccessReviewSearchServiceCountCompleteReviewersRequest = new AccessReviewSearchServiceCountCompleteReviewersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceCountCompleteReviewersResponse$Type extends MessageType<AccessReviewSearchServiceCountCompleteReviewersResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceCountCompleteReviewersResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountCompleteReviewersResponse
 */
export const AccessReviewSearchServiceCountCompleteReviewersResponse = new AccessReviewSearchServiceCountCompleteReviewersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceCountIncompleteReviewersRequest$Type extends MessageType<AccessReviewSearchServiceCountIncompleteReviewersRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceCountIncompleteReviewersRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountIncompleteReviewersRequest
 */
export const AccessReviewSearchServiceCountIncompleteReviewersRequest = new AccessReviewSearchServiceCountIncompleteReviewersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceCountIncompleteReviewersResponse$Type extends MessageType<AccessReviewSearchServiceCountIncompleteReviewersResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceCountIncompleteReviewersResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceCountIncompleteReviewersResponse
 */
export const AccessReviewSearchServiceCountIncompleteReviewersResponse = new AccessReviewSearchServiceCountIncompleteReviewersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceGetReviewerDecisionsRequest$Type extends MessageType<AccessReviewSearchServiceGetReviewerDecisionsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "sort", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewerDecisionSort", ReviewerDecisionSort, "REVIEWER_DECISION_SORT_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsRequest
 */
export const AccessReviewSearchServiceGetReviewerDecisionsRequest = new AccessReviewSearchServiceGetReviewerDecisionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceGetReviewerDecisionsResponse$Type extends MessageType<AccessReviewSearchServiceGetReviewerDecisionsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ReviewerDecision },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsResponse
 */
export const AccessReviewSearchServiceGetReviewerDecisionsResponse = new AccessReviewSearchServiceGetReviewerDecisionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReviewerDecision$Type extends MessageType<ReviewerDecision> {
    constructor() {
        super("c1.api.accessreview.v1.ReviewerDecision", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "approved", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "denied", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "total_assigned", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "approval_rate", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 6, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ReviewerDecision
 */
export const ReviewerDecision = new ReviewerDecision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserToReviewCount$Type extends MessageType<UserToReviewCount> {
    constructor() {
        super("c1.api.accessreview.v1.UserToReviewCount", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "open_reviews", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "total_reviews", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.UserToReviewCount
 */
export const UserToReviewCount = new UserToReviewCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceGetProgressByAppRequest$Type extends MessageType<AccessReviewSearchServiceGetProgressByAppRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppRequest
 */
export const AccessReviewSearchServiceGetProgressByAppRequest = new AccessReviewSearchServiceGetProgressByAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceGetProgressByAppResponse$Type extends MessageType<AccessReviewSearchServiceGetProgressByAppResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppProgressCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppResponse
 */
export const AccessReviewSearchServiceGetProgressByAppResponse = new AccessReviewSearchServiceGetProgressByAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppProgressCount$Type extends MessageType<AppProgressCount> {
    constructor() {
        super("c1.api.accessreview.v1.AppProgressCount", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "open_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "closed_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AppProgressCount
 */
export const AppProgressCount = new AppProgressCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSelectionsStatusResponse$Type extends MessageType<AccessReviewSearchServiceSelectionsStatusResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSelectionsStatusResponse", [
            { no: 1, name: "total", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "certified", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "rejected", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "skipped", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "cancelled", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "deleted", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSelectionsStatusResponse
 */
export const AccessReviewSearchServiceSelectionsStatusResponse = new AccessReviewSearchServiceSelectionsStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewRollup$Type extends MessageType<AccessReviewRollup> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewRollup", [
            { no: 1, name: "access_review", kind: "message", T: () => AccessReview },
            { no: 2, name: "assigned_tasks", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewRollup
 */
export const AccessReviewRollup = new AccessReviewRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceRollupRequest$Type extends MessageType<AccessReviewSearchServiceRollupRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceRollupRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "exclude_completed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceRollupRequest
 */
export const AccessReviewSearchServiceRollupRequest = new AccessReviewSearchServiceRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceRollupResponse$Type extends MessageType<AccessReviewSearchServiceRollupResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewRollup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceRollupResponse
 */
export const AccessReviewSearchServiceRollupResponse = new AccessReviewSearchServiceRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchEntitlementsRequest$Type extends MessageType<AccessReviewSearchServiceSearchEntitlementsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 7, name: "risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "expand_mask", kind: "message", T: () => AccessReviewAppEntitlementExpandMask },
            { no: 10, name: "exclude_facets", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsRequest
 */
export const AccessReviewSearchServiceSearchEntitlementsRequest = new AccessReviewSearchServiceSearchEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchEntitlementsResponse$Type extends MessageType<AccessReviewSearchServiceSearchEntitlementsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsResponse
 */
export const AccessReviewSearchServiceSearchEntitlementsResponse = new AccessReviewSearchServiceSearchEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchEntitlementsCountRequest$Type extends MessageType<AccessReviewSearchServiceSearchEntitlementsCountRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsCountRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 7, name: "risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsCountRequest
 */
export const AccessReviewSearchServiceSearchEntitlementsCountRequest = new AccessReviewSearchServiceSearchEntitlementsCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchEntitlementsCountResponse$Type extends MessageType<AccessReviewSearchServiceSearchEntitlementsCountResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchEntitlementsCountResponse
 */
export const AccessReviewSearchServiceSearchEntitlementsCountResponse = new AccessReviewSearchServiceSearchEntitlementsCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppRollup$Type extends MessageType<AccessReviewAppRollup> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppRollup", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "assigned_tasks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppRollup
 */
export const AccessReviewAppRollup = new AccessReviewAppRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceEntitlementRollupRef$Type extends MessageType<AccessReviewSearchServiceEntitlementRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRef
 */
export const AccessReviewSearchServiceEntitlementRollupRef = new AccessReviewSearchServiceEntitlementRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceEntitlementRollupRequest$Type extends MessageType<AccessReviewSearchServiceEntitlementRollupRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AccessReviewEntitlementRollupExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewSearchServiceEntitlementRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "50" } } } },
            { no: 7, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupRequest
 */
export const AccessReviewSearchServiceEntitlementRollupRequest = new AccessReviewSearchServiceEntitlementRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceEntitlementRollupResponse$Type extends MessageType<AccessReviewSearchServiceEntitlementRollupResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewEntitlementRollupByApp },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupResponse
 */
export const AccessReviewSearchServiceEntitlementRollupResponse = new AccessReviewSearchServiceEntitlementRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceEntitlementRollupByAppRequest$Type extends MessageType<AccessReviewSearchServiceEntitlementRollupByAppRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupByAppRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AccessReviewEntitlementRollupExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewSearchServiceEntitlementRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 7, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 8, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupByAppRequest
 */
export const AccessReviewSearchServiceEntitlementRollupByAppRequest = new AccessReviewSearchServiceEntitlementRollupByAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceEntitlementRollupByAppResponse$Type extends MessageType<AccessReviewSearchServiceEntitlementRollupByAppResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupByAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewEntitlementRollup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceEntitlementRollupByAppResponse
 */
export const AccessReviewSearchServiceEntitlementRollupByAppResponse = new AccessReviewSearchServiceEntitlementRollupByAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserRollup$Type extends MessageType<AccessReviewAppUserRollup> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserRollup", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUser },
            { no: 2, name: "task_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserRollup
 */
export const AccessReviewAppUserRollup = new AccessReviewAppUserRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAccountsWithNoIdentityTaskCounts$Type extends MessageType<AccessReviewAccountsWithNoIdentityTaskCounts> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAccountsWithNoIdentityTaskCounts", [
            { no: 1, name: "open_task_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "pending_actions_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAccountsWithNoIdentityTaskCounts
 */
export const AccessReviewAccountsWithNoIdentityTaskCounts = new AccessReviewAccountsWithNoIdentityTaskCounts$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAccountsWithNoIdentityTaskStatus$Type extends MessageType<AccessReviewAccountsWithNoIdentityTaskStatus> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAccountsWithNoIdentityTaskStatus", [
            { no: 1, name: "has_open_tasks", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "has_completed_tasks", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAccountsWithNoIdentityTaskStatus
 */
export const AccessReviewAccountsWithNoIdentityTaskStatus = new AccessReviewAccountsWithNoIdentityTaskStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewUserRollup$Type extends MessageType<AccessReviewUserRollup> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewUserRollup", [
            { no: 1, name: "user", kind: "message", T: () => UserView },
            { no: 2, name: "open_task_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 5, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "pending_actions_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 7, name: "pending_submission_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewUserRollup
 */
export const AccessReviewUserRollup = new AccessReviewUserRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceUserRollupRef$Type extends MessageType<AccessReviewSearchServiceUserRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRef
 */
export const AccessReviewSearchServiceUserRollupRef = new AccessReviewSearchServiceUserRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceUserRollupRequest$Type extends MessageType<AccessReviewSearchServiceUserRollupRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewSearchServiceUserRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "50" } } } },
            { no: 6, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupRequest
 */
export const AccessReviewSearchServiceUserRollupRequest = new AccessReviewSearchServiceUserRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceUserRollupResponse$Type extends MessageType<AccessReviewSearchServiceUserRollupResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewUserRollup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupResponse
 */
export const AccessReviewSearchServiceUserRollupResponse = new AccessReviewSearchServiceUserRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountsWithNoIdentityTaskCountsRequest$Type extends MessageType<AccountsWithNoIdentityTaskCountsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccountsWithNoIdentityTaskCountsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccountsWithNoIdentityTaskCountsRequest
 */
export const AccountsWithNoIdentityTaskCountsRequest = new AccountsWithNoIdentityTaskCountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountsWithNoIdentityTaskStatusRequest$Type extends MessageType<AccountsWithNoIdentityTaskStatusRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccountsWithNoIdentityTaskStatusRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccountsWithNoIdentityTaskStatusRequest
 */
export const AccountsWithNoIdentityTaskStatusRequest = new AccountsWithNoIdentityTaskStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceUserRollupUserNavDataRequest$Type extends MessageType<AccessReviewSearchServiceUserRollupUserNavDataRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupUserNavDataRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "current_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupUserNavDataRequest
 */
export const AccessReviewSearchServiceUserRollupUserNavDataRequest = new AccessReviewSearchServiceUserRollupUserNavDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceUserRollupUserNavDataResponse$Type extends MessageType<AccessReviewSearchServiceUserRollupUserNavDataResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupUserNavDataResponse", [
            { no: 1, name: "previous_user", kind: "message", T: () => AccessReviewUserRollup },
            { no: 2, name: "current_user", kind: "message", T: () => AccessReviewUserRollup },
            { no: 3, name: "next_user", kind: "message", T: () => AccessReviewUserRollup },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceUserRollupUserNavDataResponse
 */
export const AccessReviewSearchServiceUserRollupUserNavDataResponse = new AccessReviewSearchServiceUserRollupUserNavDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchAppUsersRequest$Type extends MessageType<AccessReviewSearchServiceSearchAppUsersRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchAppUsersRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchAppUsersRequest
 */
export const AccessReviewSearchServiceSearchAppUsersRequest = new AccessReviewSearchServiceSearchAppUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchAppUsersResponse$Type extends MessageType<AccessReviewSearchServiceSearchAppUsersResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchAppUsersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUser },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchAppUsersResponse
 */
export const AccessReviewSearchServiceSearchAppUsersResponse = new AccessReviewSearchServiceSearchAppUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppResourceRollupItem$Type extends MessageType<AccessReviewAppResourceRollupItem> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppResourceRollupItem", [
            { no: 1, name: "item", kind: "message", T: () => AppResource },
            { no: 2, name: "entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppEntitlementView },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppResourceRollupItem
 */
export const AccessReviewAppResourceRollupItem = new AccessReviewAppResourceRollupItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceRollupRef$Type extends MessageType<ResourceRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.ResourceRollupRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ResourceRollupRef
 */
export const ResourceRollupRef = new ResourceRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchSelectedResourceRollupRequest$Type extends MessageType<AccessReviewSearchServiceSearchSelectedResourceRollupRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceRollupRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewAppEntitlementExpandMask },
            { no: 6, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceRollupRequest
 */
export const AccessReviewSearchServiceSearchSelectedResourceRollupRequest = new AccessReviewSearchServiceSearchSelectedResourceRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchSelectedResourceRollupResponse$Type extends MessageType<AccessReviewSearchServiceSearchSelectedResourceRollupResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppResourceRollupItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceRollupResponse
 */
export const AccessReviewSearchServiceSearchSelectedResourceRollupResponse = new AccessReviewSearchServiceSearchSelectedResourceRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppResourceTypeRollupItem$Type extends MessageType<AccessReviewAppResourceTypeRollupItem> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppResourceTypeRollupItem", [
            { no: 1, name: "item", kind: "message", T: () => AppResourceTypeView },
            { no: 2, name: "resource_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppResourceTypeRollupItem
 */
export const AccessReviewAppResourceTypeRollupItem = new AccessReviewAppResourceTypeRollupItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceTypeRollupRef$Type extends MessageType<ResourceTypeRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.ResourceTypeRollupRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ResourceTypeRollupRef
 */
export const ResourceTypeRollupRef = new ResourceTypeRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest$Type extends MessageType<AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceTypeRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "200" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest
 */
export const AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest = new AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse$Type extends MessageType<AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppResourceTypeRollupItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse
 */
export const AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse = new AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserDetailRowSearchRef$Type extends MessageType<AccessReviewAppUserDetailRowSearchRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRef
 */
export const AccessReviewAppUserDetailRowSearchRef = new AccessReviewAppUserDetailRowSearchRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewUserNavRollupRef$Type extends MessageType<AccessReviewUserNavRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewUserNavRollupRef", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewUserNavRollupRef
 */
export const AccessReviewUserNavRollupRef = new AccessReviewUserNavRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppNavRollupRef$Type extends MessageType<AccessReviewAppNavRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppNavRollupRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppNavRollupRef
 */
export const AccessReviewAppNavRollupRef = new AccessReviewAppNavRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserDetailRowSearchRequest$Type extends MessageType<AccessReviewAppUserDetailRowSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 3, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AccessReviewAppUserDetailRowExpandMask },
            { no: 7, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppUserDetailRowSearchRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 9, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchRequest
 */
export const AccessReviewAppUserDetailRowSearchRequest = new AccessReviewAppUserDetailRowSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserDetailRowSearchResponse$Type extends MessageType<AccessReviewAppUserDetailRowSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppUserDetailRow },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowSearchResponse
 */
export const AccessReviewAppUserDetailRowSearchResponse = new AccessReviewAppUserDetailRowSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserRollupNavDataRequest$Type extends MessageType<AccessReviewAppUserRollupNavDataRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserRollupNavDataRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 3, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AccessReviewAppUserDetailRowExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserRollupNavDataRequest
 */
export const AccessReviewAppUserRollupNavDataRequest = new AccessReviewAppUserRollupNavDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserRollupNavDataResponse$Type extends MessageType<AccessReviewAppUserRollupNavDataResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserRollupNavDataResponse", [
            { no: 1, name: "previous_user", kind: "message", T: () => AppUserView },
            { no: 2, name: "current_user", kind: "message", T: () => AppUserView },
            { no: 3, name: "next_user", kind: "message", T: () => AppUserView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserRollupNavDataResponse
 */
export const AccessReviewAppUserRollupNavDataResponse = new AccessReviewAppUserRollupNavDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceNavFirstOpenSelectionRequest$Type extends MessageType<AccessReviewSearchServiceNavFirstOpenSelectionRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceNavFirstOpenSelectionRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "type", kind: "enum", T: () => ["c1.api.accessreview.v1.NextOpenSelectionType", NextOpenSelectionType, "NEXT_OPEN_SELECTION_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavFirstOpenSelectionRequest
 */
export const AccessReviewSearchServiceNavFirstOpenSelectionRequest = new AccessReviewSearchServiceNavFirstOpenSelectionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceNavFirstOpenSelectionResponse$Type extends MessageType<AccessReviewSearchServiceNavFirstOpenSelectionResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceNavFirstOpenSelectionResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["c1.api.accessreview.v1.NextOpenSelectionType", NextOpenSelectionType, "NEXT_OPEN_SELECTION_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavFirstOpenSelectionResponse
 */
export const AccessReviewSearchServiceNavFirstOpenSelectionResponse = new AccessReviewSearchServiceNavFirstOpenSelectionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceNavNextSelectionRequest$Type extends MessageType<AccessReviewSearchServiceNavNextSelectionRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceNavNextSelectionRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "current_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "type", kind: "enum", T: () => ["c1.api.accessreview.v1.NextOpenSelectionType", NextOpenSelectionType, "NEXT_OPEN_SELECTION_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavNextSelectionRequest
 */
export const AccessReviewSearchServiceNavNextSelectionRequest = new AccessReviewSearchServiceNavNextSelectionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSearchServiceNavNextSelectionResponse$Type extends MessageType<AccessReviewSearchServiceNavNextSelectionResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSearchServiceNavNextSelectionResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["c1.api.accessreview.v1.NextOpenSelectionType", NextOpenSelectionType, "NEXT_OPEN_SELECTION_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSearchServiceNavNextSelectionResponse
 */
export const AccessReviewSearchServiceNavNextSelectionResponse = new AccessReviewSearchServiceNavNextSelectionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserDetailRowExpandMask$Type extends MessageType<AccessReviewAppUserDetailRowExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserDetailRowExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "last_usage", "resource_type_ids", "app_resource_type_id", "app_resource_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowExpandMask
 */
export const AccessReviewAppUserDetailRowExpandMask = new AccessReviewAppUserDetailRowExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserDetailRowTaskDetails$Type extends MessageType<AccessReviewAppUserDetailRowTaskDetails> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserDetailRowTaskDetails", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "task", kind: "message", T: () => TaskView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRowTaskDetails
 */
export const AccessReviewAppUserDetailRowTaskDetails = new AccessReviewAppUserDetailRowTaskDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppUserDetailRow$Type extends MessageType<AccessReviewAppUserDetailRow> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppUserDetailRow", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUserView },
            { no: 2, name: "entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppUserDetailRowTaskDetails },
            { no: 3, name: "AllTicketsCompleted", kind: "scalar", jsonName: "AllTicketsCompleted", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "pending_actions_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 7, name: "open_task_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppUserDetailRow
 */
export const AccessReviewAppUserDetailRow = new AccessReviewAppUserDetailRow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserRollup$Type extends MessageType<AppUserRollup> {
    constructor() {
        super("c1.api.accessreview.v1.AppUserRollup", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUserView },
            { no: 3, name: "open_task_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "pending_submission_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AppUserRollup
 */
export const AppUserRollup = new AppUserRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUserRollupRequest$Type extends MessageType<SearchAppUserRollupRequest> {
    constructor() {
        super("c1.api.accessreview.v1.SearchAppUserRollupRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 3, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppUserExpandMask },
            { no: 7, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppUserDetailRowSearchRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "50" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchAppUserRollupRequest
 */
export const SearchAppUserRollupRequest = new SearchAppUserRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUserRollupResponse$Type extends MessageType<SearchAppUserRollupResponse> {
    constructor() {
        super("c1.api.accessreview.v1.SearchAppUserRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRollup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchAppUserRollupResponse
 */
export const SearchAppUserRollupResponse = new SearchAppUserRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppRollup$Type extends MessageType<AppRollup> {
    constructor() {
        super("c1.api.accessreview.v1.AppRollup", [
            { no: 1, name: "app", kind: "message", T: () => AppView },
            { no: 2, name: "task_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "open_task_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "pending_submission_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AppRollup
 */
export const AppRollup = new AppRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppRollupRequest$Type extends MessageType<SearchAppRollupRequest> {
    constructor() {
        super("c1.api.accessreview.v1.SearchAppRollupRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppNavRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "50" } } } },
            { no: 7, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchAppRollupRequest
 */
export const SearchAppRollupRequest = new SearchAppRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppRollupResponse$Type extends MessageType<SearchAppRollupResponse> {
    constructor() {
        super("c1.api.accessreview.v1.SearchAppRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppRollup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchAppRollupResponse
 */
export const SearchAppRollupResponse = new SearchAppRollupResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewSearchService
 */
export const AccessReviewSearchService = new ServiceType("c1.api.accessreview.v1.AccessReviewSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceSearchRequest, O: AccessReviewSearchServiceSearchResponse },
    { name: "SelectionsStatus", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceSelectionsStatusRequest, O: AccessReviewSearchServiceSelectionsStatusResponse },
    { name: "CountOpenReviewsByUser", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceCountOpenReviewsByUserRequest, O: AccessReviewSearchServiceCountOpenReviewsByUserResponse },
    { name: "GetProgressByApp", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceGetProgressByAppRequest, O: AccessReviewSearchServiceGetProgressByAppResponse },
    { name: "CountCompleteReviewers", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceCountCompleteReviewersRequest, O: AccessReviewSearchServiceCountCompleteReviewersResponse },
    { name: "CountIncompleteReviewers", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceCountIncompleteReviewersRequest, O: AccessReviewSearchServiceCountIncompleteReviewersResponse },
    { name: "GetReviewerDecisions", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceGetReviewerDecisionsRequest, O: AccessReviewSearchServiceGetReviewerDecisionsResponse },
    { name: "Rollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceRollupRequest, O: AccessReviewSearchServiceRollupResponse },
    { name: "EntitlementRollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceEntitlementRollupRequest, O: AccessReviewSearchServiceEntitlementRollupResponse },
    { name: "EntitlementRollupByApp", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceEntitlementRollupByAppRequest, O: AccessReviewSearchServiceEntitlementRollupByAppResponse },
    { name: "UserRollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceUserRollupRequest, O: AccessReviewSearchServiceUserRollupResponse },
    { name: "AccountsWithNoIdentityTaskCount", options: { "authz.method": { role: "VIEWER" } }, I: AccountsWithNoIdentityTaskCountsRequest, O: AccessReviewAccountsWithNoIdentityTaskCounts },
    { name: "AccountsWithNoIdentityTaskStatus", options: { "authz.method": { role: "VIEWER" } }, I: AccountsWithNoIdentityTaskStatusRequest, O: AccessReviewAccountsWithNoIdentityTaskStatus },
    { name: "UserRollupNavData", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceUserRollupUserNavDataRequest, O: AccessReviewSearchServiceUserRollupUserNavDataResponse },
    { name: "SearchEntitlements", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceSearchEntitlementsRequest, O: AccessReviewSearchServiceSearchEntitlementsResponse },
    { name: "SearchEntitlementsCount", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceSearchEntitlementsCountRequest, O: AccessReviewSearchServiceSearchEntitlementsCountResponse },
    { name: "SearchSelectedResourceRollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceSearchSelectedResourceRollupRequest, O: AccessReviewSearchServiceSearchSelectedResourceRollupResponse },
    { name: "SearchSelectedResourceTypeRollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest, O: AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse },
    { name: "AppUserDetailRowRollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewAppUserDetailRowSearchRequest, O: AccessReviewAppUserDetailRowSearchResponse },
    { name: "AppUserDetailRowRollupNavData", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewAppUserRollupNavDataRequest, O: AccessReviewAppUserRollupNavDataResponse },
    { name: "NavFirstOpenSelection", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceNavFirstOpenSelectionRequest, O: AccessReviewSearchServiceNavFirstOpenSelectionResponse },
    { name: "NavNextSelection", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSearchServiceNavNextSelectionRequest, O: AccessReviewSearchServiceNavNextSelectionResponse },
    { name: "SearchAppUserRollup", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppUserRollupRequest, O: SearchAppUserRollupResponse },
    { name: "SearchAppRollup", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppRollupRequest, O: SearchAppRollupResponse }
]);
